import { render, staticRenderFns } from "./pvi.vue?vue&type=template&id=105f7fd0&"
import script from "./pvi.vue?vue&type=script&lang=js&"
export * from "./pvi.vue?vue&type=script&lang=js&"
import style0 from "./pvi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports